@if(pwaUpdate.available() && !pwaUpdate.deferred()) {
  <aside class="pwa-update" aria-label="Actualización de la aplicación">
    <div role="status" aria-live="polite">
      <strong>{{ pwaUpdate.recovery() ? 'Necesitamos actualizar la aplicación' : 'Hay una nueva versión disponible' }}</strong>
      <span>{{ pwaUpdate.error() || 'Actualizá cuando quieras. La aplicación se va a recargar.' }}</span>
    </div>
    <div class="pwa-update__actions">
      <button type="button" class="pwa-update__apply" (click)="pwaUpdate.apply()" [disabled]="pwaUpdate.reloading()">{{ pwaUpdate.reloading() ? 'Actualizando…' : 'Actualizar' }}</button>
      <button type="button" (click)="pwaUpdate.later()" [disabled]="pwaUpdate.reloading()">Más tarde</button>
    </div>
  </aside>
}
<main class="app-shell">
  <router-outlet></router-outlet>
</main>
